import React from 'react';
import AddIcon from '@mui/icons-material/Add';
import './Toolbar.css';

interface ToolbarProps {
    onCreateTask: () => void;
}

const Toolbar: React.FC<ToolbarProps> = ({ onCreateTask }) => {
    return (
        <div className="toolbar">
            <div className="branding">Task Manager</div>
            <button className="create-task-button" onClick={onCreateTask}>
                <AddIcon /> Create New Task
            </button>
        </div>
    );
};

export default Toolbar;